import React, { useState, useRef } from "react";
import img_profile from "../../images/profile.svg";
import img_1 from "../../images/rabbitlife-logo.png";
import {
  getMenuParameterAPI,
  getMenuByRoleAPI,
  insertActivityLog,
} from "../Home/homeService/homeService";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export default function Header_Home(props) {
  const [menu, setMenu] = useState([]);
  const [role, setRole] = useState(localStorage.getItem("profile") || "");
  const [perRole, setPerRole] = useState(localStorage.getItem("role" || ""));
  const [age, setAge] = useState(localStorage.getItem("age"));
  let navigate = useNavigate();
  const location = useLocation();
  const [historyAnchor, setHistoryAnchor] = useState(null);
  const historyOpen = Boolean(historyAnchor);

  const handleGetMenu = () => {
    // console.log(role);
    if (role == "Customer") {
      getMenuParameterAPI()
        .then((res) => {
          // console.log("getMenuParameterAPI ", res);
          setMenu(res.data.payload);
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      getMenuByRoleAPI(perRole)
        .then((res) => {
          // console.log("getMenuByRoleAPI ", res);
          setMenu(res.data.payload);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const logout = () => {
    if (localStorage.getItem("profile") == "POS") {
      localStorage.clear();
      navigate("/login");
    } else {
      localStorage.clear();
      navigate("/");
    }
  };

  useEffect(() => {
    // console.log(age);
    handleGetMenu();
  }, []);

  const handleGoToRoute = (url) => {
    const path = url.split("/")[1];
    if (path === "policyList") {
      handleSubmitLog("ข้อมูลกรมธรรม์");
    } else if (path === "downloadDoc") {
      handleSubmitLog("การดาวน์โหลดเอกสาร");
    } else if (path === "sendDoc") {
      handleSubmitLog("การนำส่งเอกสารแสดงตน");
    }
    navigate(url);
  };

  const handleSubmitLog = async (type) => {
    const citizen = localStorage.getItem("customer_id");

    if (!citizen) {
      console.error("No encrypted citizen ID found in localStorage.");
      return;
    }

    const decrypted = decryptCardNumber(
      citizen,
      process.env.REACT_APP_ENCRYPT_DATA
    ); // ตรวจสอบว่า secretKey ถูกต้องหรือไม่
    const activityMap = {
      citizenID: decrypted,
      activityType: type,
    };
    await insertActivityLog(activityMap);
  };

  const goToHome = () => {
    navigate("/home");
  };

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const [showHistoryDD, setShowHistoryDD] = useState(false);
  const historyRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (historyRef.current && !historyRef.current.contains(e.target)) {
        setShowHistoryDD(false);
      }
    };
    document.addEventListener("click", onClickOutside);
    return () => document.removeEventListener("click", onClickOutside);
  }, []);

  return (
    <section className="sec-navbar">
      <nav className="navbar navbar-expand-lg navbar-light bg-light px-lg-5 nav-h pl-3">
        <div className="navbar-brand">
          <img src={img_1} height="48" alt="" />
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <div className="d-flex mx-auto justify-content-between align-items-center">
            <ul className="navbar-nav d-flex">
              <li
                className="nav-item active"
                style={{
                  backgroundColor:
                    location.pathname === "/home" ? "#ff5e43" : "#F8F9FA",
                  display: "grid",
                  placeItems: "center",
                  borderRadius: "10px",
                }}
              >
                <a
                  type="button"
                  className="nav-link"
                  style={{
                    backgroundColor:
                      location.pathname === "/home" ? "#ff5e43" : "#F8F9FA",
                  }}
                  onClick={() => {
                    goToHome();
                  }}
                >
                  <a
                    style={{
                      color:
                        location.pathname === "/home" ? "#F8F9FA" : "black",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    หน้าหลัก
                  </a>
                </a>
              </li>
              {menu.map((post, index) => (
                <li
                  key={index}
                  className="nav-item active"
                  style={{
                    backgroundColor:
                      location.pathname === post.urlLink
                        ? "#ff5e43"
                        : "#F8F9FA",
                    display: "grid",
                    placeItems: "center",
                    borderRadius: "10px",
                  }}
                >
                  <a
                    type="button"
                    className="nav-link"
                    style={{
                      cursor: "pointer",
                      textDecoration: "none",
                      textAlign: "center",
                      backgroundColor:
                        location.pathname === post.urlLink
                          ? "#ff5e43"
                          : "#F8F9FA",
                      display: "flex",
                      justifyContent: "center",
                    }}
                    onClick={(e) => {
                      if (post.urlLink === "/sendDoc") {
                        handleSubmitLog("การนำส่งเอกสารแสดงตน");
                        navigate("/sendDoc", { state: { age } });
                      } else if (post.menuName === "ประวัติการเข้าใช้งาน") {
                        setHistoryAnchor(e.currentTarget);
                      } else {
                        handleGoToRoute(post.urlLink);
                      }
                    }}
                  >
                    <a
                      id="history-button"
                      style={{
                        color:
                          location.pathname === post.urlLink
                            ? "#F8F9FA"
                            : "black",
                        display: "flex",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      {post.menuName}
                    </a>

                    {/* Dropdown แบบลอย โปร่ง เหมือนภาพสอง */}
                    <Menu
                      anchorEl={historyAnchor}
                      open={historyOpen}
                      onClose={() => setHistoryAnchor(null)}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          mt: 1.25,
                          minWidth: 240,
                          borderRadius: 2,
                          boxShadow: "none",
                          border: "2px solid",
                          "& .MuiMenuItem-root:not(:last-of-type)": {
                            borderBottom: "1px solid #e6e6e6", // เส้นคั่น
                          },
                          "& .MuiMenuItem-root": {
                            paddingTop: 1,
                            paddingBottom: 1,
                          },
                        },
                      }}
                      MenuListProps={{ "aria-labelledby": "history-button" }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleSubmitLog("ประวัติการเข้าใช้งาน");
                          setHistoryAnchor(null);
                          setTimeout(() => navigate("/ActivityLogIn"), 0);
                        }}
                      >
                        ประวัติการเข้าใช้งาน
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleSubmitLog("การจัดส่ง OTP");
                          setHistoryAnchor(null);
                          setTimeout(() => navigate("/SendOTPHistory"), 0);
                        }}
                      >
                        การจัดส่ง OTP
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleSubmitLog("ประวัติการลงทะเบียน");
                          setHistoryAnchor(null);
                          setTimeout(() => navigate("/RegisterHistory"), 0);
                        }}
                      >
                        ประวัติการลงทะเบียน
                      </MenuItem>
                    </Menu>
                  </a>
                </li>
              ))}
            </ul>
            <div
              className="d-lg-none d-block dropdown-mobile"
              style={{ marginBottom: "90px" }}
            >
              <button className="d-block info-profile-mobile">
                <label>
                  <img
                    src={img_profile}
                    alt=""
                    height="70"
                    className="mar-mi-20"
                  />
                  <br />
                  {localStorage.getItem("first_name")}{" "}
                  {localStorage.getItem("last_name")}
                </label>
              </button>
              <div className="dropdown-content-mobile">
                <a onClick={logout}>Logout</a>
              </div>
            </div>
          </div>
        </div>
        <div className="form-inline my-2 my-lg-0 mx-3 d-none d-lg-block">
          <button className="d-block info-profile">
            <div className="dropdown info">
              <button className="d-block info-profile d-flex justify-content-center align-items-center">
                {/* <div className='col-7'>  */}
                <span className="text-nowrap">
                  {localStorage.getItem("first_name")}{" "}
                  {localStorage.getItem("last_name")}
                </span>
                <label>
                  <br />
                  <img
                    src={img_profile}
                    alt=""
                    height="70"
                    className="mar-mi-20"
                  />
                </label>
                {/* </div>  */}
              </button>
              <div className="dropdown-content">
                <a onClick={logout}>Logout</a>
              </div>
            </div>
          </button>
        </div>
      </nav>
    </section>
  );
}
